import React from "react";
import { Stack, Typography } from "@mui/material";
import IwSwitch from "../app/IwSwitch";
import { useAtom } from "jotai";
import { showAllCommentsAtom } from "../../stores/jotai/scoring/showAllComments";

const ScoringCommentFilterSwitch = () => {
    const [showAllComments, setShowAllComments] = useAtom(showAllCommentsAtom);

    const onChange = () => {
        setShowAllComments(!showAllComments);
    };

    return (
        <Stack
            direction="row"
            sx={{
                alignItems: "center",
                cursor: "pointer",
            }}
            spacing={1}
            onClick={onChange}
        >
            <Typography sx={{ userSelect: "none" }}>Show All Comments</Typography>
            <IwSwitch checked={showAllComments} />
        </Stack>
    );
};

export default ScoringCommentFilterSwitch;
